import { Color } from 'three';
import { IGradient } from '../types';

export const INFERNO: IGradient = [
  [0.0, new Color(0.077, 0.042, 0.206)],
  [0.1, new Color(0.225, 0.036, 0.388)],
  [0.2, new Color(0.373, 0.074, 0.432)],
  [0.3, new Color(0.522, 0.128, 0.42)],
  [0.4, new Color(0.665, 0.182, 0.37)],
  [0.5, new Color(0.797, 0.255, 0.287)],
  [0.6, new Color(0.902, 0.364, 0.184)],
  [0.7, new Color(0.969, 0.516, 0.063)],
  [0.8, new Color(0.988, 0.683, 0.072)],
  [0.9, new Color(0.961, 0.859, 0.298)],
  [1.0, new Color(0.988, 0.998, 0.645)],
];
